import { gql } from "@apollo/client";

export const LCSC_query = gql`
  query lcsc_query($query: String!) {
    lcsc_query(query: $query) {
      products {
        ifRoHS
        images {
          data {
            url
            size
          }
          sort
          type
        }
        url
        stock
        package
        mpn
        mfrLink
        manufacturer
        prices {
          price
          price2
          quantity
        }
        number
      }
    }
  }
`;
